import { inject, Injectable } from '@angular/core';
import { ArticleVO } from '@article/model/vo/article.vo';
import { RedirectAfterAddingInvalidArticleComponent } from '@shared/window/open-in-new-window/redirect-after-adding-invalid-article.component';
import { CopyFromComponent } from './copy-modal/copy-from.component';
import { WindowService } from './window/window.service';
import { TextInputModalComponent } from '@shared/text-input-modal/text-input-modal.component';

@Injectable({providedIn: 'root'})
export class SharedComponentsPresenter {
  private readonly windowService = inject(WindowService);

  public presentOpenInNewWindowComponent(articleVO: ArticleVO): void {
    this.windowService.showModal(RedirectAfterAddingInvalidArticleComponent, {
      initialState: {
        articleVO,
      },
      keyboard: true,
    });
  }

  public openCopyFromPopup(calledBy: 'endplate' | 'accessory' | 'properties'): Promise<string> {
    return this.windowService.showModalFinish(CopyFromComponent, {
      initialState: {calledBy},
    });
  }

  public openTextInputDialog(title: string, description: string = ''): Promise<string> {
    return this.windowService.showModalFinish(TextInputModalComponent, {
        initialState: {title, description}
      }
    );
  }
}
